import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Text } from '@amzn/dvui/dist/Text'
import { RecordRefTag } from '@utils'
import { ModalTrigger } from '../../utils/modalTrigger/ModalTrigger'
import CopyLinkButton from '../copyLinkButton/copyLinkButton'
import * as st from './shareWidget.module.scss'
import { ShareIcons } from './shareIcons/shareIcons'

export interface IShareModalProps {
  shareWidgetModel?: WpsRuntime.atv.wps.ShareWidgetModelProps
}

const shareContent = ({ shareIcons, pageUrl, copyUrlReftag, copyLinkText, linkCopiedText }: WpsRuntime.atv.wps.ShareWidgetModelProps) =>
  <div>
    {shareIcons && <ShareIcons shareIcons={shareIcons} />}
    <CopyLinkButton url={pageUrl} reftag={copyUrlReftag} copyLinkText={copyLinkText} linkCopiedText={linkCopiedText} />
  </div>


const shareHeader = (headerText: string) =>
  <strong className={st.shareHeader}>
    <Text string={headerText}/>
  </strong>

export const ShareModalComp = ({ shareWidgetModel }: IShareModalProps) => {

  return shareWidgetModel ?
    <ModalTrigger
      size='xs'
      modalHeader={shareHeader(shareWidgetModel.shareText)}
      modalContent={shareContent(shareWidgetModel)}
      modalId="share-modal"
      toggle={({ openModalClickHandler }) => (
        // TODO(AVWebDP-691): Get the reftag from the new Node package
        <RecordRefTag refTag="atv_dp_share_open">
          <button id="shareTrigger" className={st.shareButton} onClick={openModalClickHandler}
                  data-automation-id="share-button" data-testid="share-button">
            <Text string={shareWidgetModel.shareText} />
          </button>
        </RecordRefTag>
      )}
      className={st.shareModal}
    /> : null
}

export const ShareModal = ShareModalComp
